module.exports = __webpack_public_path__ + "fonts/Golos-Text_Medium.2b4ee7e.woff2";